import { useState, useEffect, useRef } from "react";
import { fetchPlaylist } from "../Api/fetchPlaylist.js";

export type VideoData = Record<string, Record<any, any>>;
export type DurationMap = Record<number, string>;

export type PlaylistRecord = {
  videoData: VideoData;
  durationMap: DurationMap;
  durationInSeconds: number;
  stationName: string;
  playlistTimestamp: Date | null;
};

export const usePlaylistRecord: () => PlaylistRecord = () => {
  const params = new URLSearchParams(window.location.search);
  const playlistId = params.get("playlistId");
  const userPlaylist = !!params.get("userPlaylist");

  const [videoData, setVideoData] = useState<VideoData>({});
  const [durationMap, setDurationMap] = useState<DurationMap>({});
  const [durationInSeconds, setDurationInSeconds] = useState<number>(0);
  const fetchedPlaylistRef = useRef<Boolean>(false);
  const [stationName, setStationName] = useState<string>("");
  const [playlistTimestamp, setPlaylistTimestamp] = useState<Date | null>(null);

  useEffect(() => {
    if (fetchedPlaylistRef.current) return;

    if (playlistId) {
      fetchedPlaylistRef.current = true;
      fetchPlaylist({
        recordName: userPlaylist ? "user_playlists" : "playlists",
        playlistId,
      }).then((playlist) => {
        console.log("000", playlist);
        if (!playlist) {
          console.error("No playlist found", playlist);
        }
        setStationName(playlist.name);
        setVideoData(playlist.videoData);
        setDurationMap(playlist.durationMap);
        setDurationInSeconds(playlist.durationInSeconds);
        setPlaylistTimestamp(new Date(playlist.timestamp));
      });
    }
  }, []);

  return {
    videoData,
    durationMap,
    durationInSeconds,
    stationName,
    playlistTimestamp,
  };
};
